var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"buttonL",class:[_vm.color, _vm.icon],attrs:{"type":_vm.type},on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.btnTxt)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }